import React from "react";
import {Box, TagsInput, NumberInput, Tooltip} from "@mantine/core";

interface ExtensionInputsProps {
    extensions: string[];
    minAge: number;
    onExtensionsChange: (value: string[]) => void;
    onMinAgeChange: (value: number) => void;
    disabled?: boolean;
}

export const ExtensionInputs: React.FC<ExtensionInputsProps> = ({
                                                                    extensions,
                                                                    minAge,
                                                                    onExtensionsChange,
                                                                    onMinAgeChange,
                                                                    disabled,
                                                                }) => {

    return (
        <Box style={{display: "flex", gap: "0.5rem", marginTop: "0.25rem"}}>
            <Tooltip label={"File extensions without the leading '.'"}>
                <TagsInput
                    size="xs"
                    label="extensions"
                    placeholder="Add extension"
                    value={extensions}
                    onChange={onExtensionsChange}
                    styles={{
                        input: {
                            overflow: "auto",
                            maxHeight:"5em"
                        }
                    }}
                    style={{width: "15rem"}}
                    disabled={disabled}
                />
            </Tooltip>
            <Tooltip
                label={"Minimum age of files before upload, in seconds. This can help ensure files are fully written before upload."}
            >
                <NumberInput
                    label={"min age"}
                    size="xs"
                    placeholder="Min age"
                    value={minAge}
                    onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                        const numValue = parseInt(e.currentTarget.value, 10);
                        onMinAgeChange(isNaN(numValue) ? 0 : numValue);
                    }}
                    style={{width: "5rem"}}
                    min={0}
                    disabled={disabled}
                />
            </Tooltip>
        </Box>
    );
};
